import React from "react";
import {
  Nav,
  NavLink,
  NavbarContainer,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  //MobileNavLogo,
  MobileLink,
} from "./NavbarStyledComponent";
//import { DiCssdeck } from "react-icons/di";
//import { FaBars } from "react-icons/all";
import { Bio } from "../../data/constants";
//import { Close, CloseRounded } from "@mui/icons-material";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";
import { TbLetterD } from "react-icons/tb";
import { TbLetterG } from "react-icons/tb";
import { FaGreaterThan } from "react-icons/fa6";
import { FaLessThan } from "react-icons/fa6";
import { RxSlash } from "react-icons/rx";
import { FaBars } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();
  const location = useLocation();
  const onHome = location.pathname === "/";
  const anchor = (hash) => (onHome ? hash : `/${hash}`);
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/" href="/">
          <a
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              marginBottom: "20;",
              cursor: "pointer",
            }}
          >
            <FaLessThan size="1rem" />
            <TbLetterG size="2rem" />
            <TbLetterD size="2rem" />
            <RxSlash size="2rem" />
            <FaGreaterThan size="1rem" />
          </a>
        </NavLogo>
        <MobileIcon>
          <FaBars
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          />
        </MobileIcon>
        <NavItems>
          <NavLink href={anchor("#about")}>About</NavLink>
          <NavLink href={anchor("#skills")}>Skills</NavLink>
          <NavLink href={anchor("#experience")}>Experience</NavLink>
          <NavLink href={anchor("#projects")}>Projects</NavLink>
          <NavLink href={anchor("#education")}>Education</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton
            href="https://www.linkedin.com/in/gaspar-fontineli/"
            target="_blank" // This will open the link in a new tab
            rel="noopener noreferrer" // Added for security reasons when using target="_blank"
            aria-label="View LinkedIn Profile" // Accessibility enhancement
          >
            LinkedIn Profile
          </GitHubButton>
        </ButtonContainer>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">
            Github Profile
          </GitHubButton>
        </ButtonContainer>
        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <MobileLink
              href={anchor("#about")}
              onClick={() => { setIsOpen(!isOpen); }}
            >
              About
            </MobileLink>
            <MobileLink
              href={anchor("#projects")}
              onClick={() => { setIsOpen(!isOpen); }}
            >
              Projects
            </MobileLink>
            <MobileLink
              href={anchor("#skills")}
              onClick={() => { setIsOpen(!isOpen); }}
            >
              Skills
            </MobileLink>
            <MobileLink
              href={anchor("#education")}
              onClick={() => { setIsOpen(!isOpen); }}
            >
              Education
            </MobileLink>
            <GitHubButton
              style={{
                padding: "10px 16px",
                background: `${theme.primary}`,
                color: "white",
                width: "max-content",
              }}
              href={Bio.github}
              target="_blank"
            >
              Github Profile
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
